import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ROUTER_TOKENS } from '../../app.routes';

@Component({
  selector: 'app-not-found',
  imports: [ButtonModule],
  template: `
    <div class="flex h-screen w-screen align-items-center justify-content-center">
      <div class="flex flex-column align-items-center w-6 gap-3">
        <img class="w-20rem h-20rem" src="assets/images/img-404-page.png" alt="missing-permission" />
        <p class="text-2xl text-color font-semibold">Page Not Found</p>
        <div class="w-6 mt-6">
          <p-button styleClass="flex justify-content-center w-full" (onClick)="routeToApp()">
            <p>Back To Home</p>
          </p-button>
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class NotFoundComponent {
  router = inject(Router);

  routeToApp() {
    this.router.navigateByUrl(ROUTER_TOKENS.APP);
  }
}
